package com.exura.components.pageTypography

import androidx.compose.runtime.Composable
import com.exura.surface
import com.exura.ui.Dimens
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.ComponentKind
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.CssStyleVariant
import com.varabyte.kobweb.silk.style.addVariant
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.palette.border
import com.varabyte.kobweb.silk.theme.colors.palette.overlay
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.LineStyle

@Composable
internal fun GeneralCardEntry(
    modifier: Modifier = Modifier,
    variant: CssStyleVariant<CardEntryKind>? = null,
    content: @Composable () -> Unit,
) {
    Box(
        modifier = CardEntryStyle.toModifier(variant)
            .then(modifier),
        contentAlignment = Alignment.Center,
    ) {
        content()
    }
}

sealed interface CardEntryKind : ComponentKind

val CardEntryStyle = CssStyle<CardEntryKind> {
    val palette = colorMode.toPalette()
    base {
        Modifier
            .border {
                width(Dimens.cardEntryBorderWidth)
                style(LineStyle.Solid)
                color(palette.border)
            }
            .borderRadius(Dimens.cardEntryBorderRadius)
            .padding(leftRight = Dimens.cardEntryIndent, topBottom = Dimens.cardEntryWrapping)
    }
}

val GhostCardEntryVariant = CardEntryStyle.addVariant {
    base {
        Modifier
            .border(style = LineStyle.None)
    }
}

val DisabledCardEntryVariant = CardEntryStyle.addVariant {
    val palette = colorMode.toPalette()
    base {
        Modifier
            .backgroundColor(palette.overlay)
            .opacity(0.5)
    }
}

val HighlightedCardEntryVariant = CardEntryStyle.addVariant {
    val palette = colorMode.toPalette()
    base {
        Modifier
            .backgroundColor(palette.surface)
    }
}

val InteractiveCardEntryVariant = CardEntryStyle.addVariant {
    val palette = colorMode.toPalette()
    hover {
        Modifier
            .flexGrow(0)
            .backgroundColor(palette.surface)
            .fontWeight(FontWeight.Medium)
    }
}
